import * as React from 'react';
import classNames from 'classnames';

export interface ModalFooterProps {
  children?: React.ReactNode;
  className?: string;
}

const ModalFooter: React.FC<ModalFooterProps> = (props: ModalFooterProps) => {
  const { children, className } = props;

  const modalFooterClass = classNames(className, 'ui-modal-footer');

  return <footer className={modalFooterClass}>{children}</footer>;
};

export default ModalFooter;
